import AddEvenimentForm from './eveniments/AddEvenimentForm'
import EvenimentsList from './eveniments/EvenimentsList'
import EvenimentsTimeline from './eveniments/EvenimentsTimeline'
import EvenimentsPanelTimeline from './eveniments/EvenimentsPanelTimeline'

export const Eveniments = {
    AddForm: AddEvenimentForm,
    List: EvenimentsList,
    Timeline: EvenimentsTimeline,
    PanelTimeline: EvenimentsPanelTimeline,
}


// WEBPACK FOOTER //
// ./src/components/Eveniments.js